<template>
  <div v-if="isDebugEnvironment"
       class="debug-actions menu-option">
    <!-- FOR TESTING PURPOSES ONLY -->
    <div class="debug-actions--toggle"
         v-b-toggle.debugActionsCollapse>
      <b-row no-gutters>
        <b-col class="button--debug-action"
               cols="12">
          <inline-svg class="icon--brand"
                      src="DebugIcon">
          </inline-svg>
          {{ $t('debug_actions') }}
        </b-col>
      </b-row>
    </div>
    <b-collapse id="debugActionsCollapse"
                class="debug-actions--collapse"
                v-model="showDebugActions">
      <b-row v-for="(action, index) of allViewableActions"
             class="spacing-1"
             :class="{'debug-action': index !== (allViewableActions.length - 1)}"
             :key="`debugAction${index}`">
        <b-col>
          <button class="btn"
                  type="button"
                  @click="action.function">
            {{ action.name }}
          </button>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
// Elements
import InlineSvg from './InlineSvg.vue'

// Libraries
import { mapState } from 'vuex'

// Utilities
import analytics from '../../../utility/analyticsUtil'
import environment from '../../../utility/environmentUtils'

// Constants
import { AnalyticsConstants } from '../../../constants.js'

export default {
  name: 'debug-actions',

  components: {
    InlineSvg
  },

  data () {
    return {
      showDebugActions: false,
      isDebugEnvironment: environment.isLowerEnv(),
      debugActions: [
        {
          name: 'Login as Customer',
          display: !this.authenticated,
          function: () => {
            this.$router.push({ name: 'SimulateCustomer' })
            this.showDebugActions = false
            this.$store.commit('display/toggleSidebar')
          }
        },
        {
          name: 'Trigger Inbox Message',
          display: true,
          function: () => {
            analytics.logEvent(AnalyticsConstants.eventName.submitContent, { item_id: 'inboxMessageTest', 'item_name': 'Inbox Message Test', 'item_variant': 'true' }, { logMarketingEvent: true })
          }
        },
        {
          name: 'Trigger In App Message',
          display: true,
          function: () => {
            analytics.logEvent(AnalyticsConstants.eventName.submitContent, { item_id: 'inAppMessageTest', 'item_name': 'In App Message Test', 'item_variant': 'true' }, { logMarketingEvent: true })
          }
        }
      ]
    }
  },

  computed: {
    allViewableActions () {
      return this.debugActions.filter(action => action.display)
    },

    ...mapState('session', ['authenticated'])
  }
}
</script>

<style lang="scss">
@use '../../../assets/styles/colors';

.debug-actions {
  padding-left: 1.5rem;
}

.button--debug-action {
  font-size: 18px;

  .icon--brand {
    width: 2rem;
    height: 2rem;
    margin-right: 0.25rem;
    margin-left: -0.25rem;
  }
}

.debug-action {
  border-bottom: solid 1px colors.$gray-200;
}

#debugActionsCollapse {
  position: relative;
  z-index: 100;
  background-color: colors.$white;
  border: solid 1px colors.$gray-200;
  border-radius: .25rem;
  box-shadow: 0 2px 10px 0 colors.$black-25op;
}
</style>

<i18n>
  {
    "en": {
      "debug_actions": "Debug Actions"
    }
  }
</i18n>
